import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "custom-loader" }
const _hoisted_2 = ["width"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M512 257C370.314 257 256 371.314 256 513C256 654.686 370.314 769 512 769C653.686 769 768 654.686 768 513C768 371.314 653.686 257 512 257ZM417.006 674.006H375.145V590.283H417.006V674.006ZM491.069 674.006H449.208V508.17H491.069V674.006ZM565.132 674.006H523.27V424.447H565.132V674.006ZM606.994 424.447V382.585H565.132V340.723H648.855V382.585V379.365V385.805V424.447H606.994Z",
  class: "custom-loader-pulse"
}, null, -1)
const _hoisted_4 = [
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock("svg", {
      width: _ctx.width,
      viewBox: "0 0 1025 1025",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, _hoisted_4, 8, _hoisted_2))
  ]))
}